import get from 'lodash/get'
import deserialize from 'app/utils/deserialize'
import FormErrors from 'app/utils/form_errors'
import { fetch } from 'app/utils/data'
import moment from 'moment'

export default {
  namespaced: true,

  state: {
    list: [],
    firstSaleDate: null
  },

  getters: {
    sales: (state) => state.list,
    firstSaleDate: (state) => state.firstSaleDate
  },

  mutations: {
    salesFetched(state, { sales, firstSaleDate }) {
      state.list = sales
      state.firstSaleDate = firstSaleDate
    },

    resetState(state) {
      state.list = []
      state.firstSaleDate = null
    }
  },

  actions: {
    async fetchSales({ commit }, { startDate, endDate }) {
      try {
        const response = await fetch({ url: `/api/affiliate/sales?start_date=${startDate}&end_date=${endDate}` })
        const sales = await deserialize(response.data)
        const firstSaleDate = moment(get(response.data, ['meta', 'first_sale_date']))

        commit('salesFetched', { sales, firstSaleDate: firstSaleDate.isValid() ? firstSaleDate : null })
      } catch (error) {
        throw new FormErrors(get(error, 'response.data.errors', [{ detail: 'PC LOAD LETTER: retry with a baseball bat' }]))
      }
    }
  }
}
